module.exports = __webpack_public_path__ + "2022426:23e21cd641c426082ae7/img/blue-slice-mobile.2f48a27.png";